import React from 'react';
import { Layout, Divider, Button } from 'antd';
import './styles.css';

interface AdminHeaderProps {
  onLogout: () => void;
  onChangePassword: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({
  onChangePassword,
  onLogout,
}) => {
  return (
    <Layout.Header className="admin-header">
      <Button type="link" onClick={onChangePassword}>
        Change password
      </Button>
      <Divider type="vertical" />
      <Button type="link" onClick={onLogout}>
        Logout
      </Button>
    </Layout.Header>
  );
};

export default AdminHeader;
